"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProfile = void 0;
var swr_1 = __importDefault(require("swr"));
var useInterests_1 = __importDefault(require("./useInterests"));
var useUserGroups_1 = require("./useUserGroups");
var useCurrentUser_1 = __importDefault(require("./useCurrentUser"));
var react_1 = require("react");
var config_1 = require("../util/config");
var api_1 = require("../util/api");
var types_1 = require("../types");
var useProfile = function (slug, config) {
    var _a;
    if (config === void 0) { config = null; }
    var _b = (0, react_1.useContext)(config_1.ChocolatesContext), apiBase = _b.apiBase, auth0Token = _b.authToken;
    var me = (0, useCurrentUser_1.default)().data;
    var _c = (0, swr_1.default)(slug ? "users/".concat(slug) : null, function (path) { return __awaiter(void 0, void 0, void 0, function () {
        var body, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, api_1.request)({
                            apiBase: apiBase,
                            auth0Token: auth0Token,
                            path: path,
                            method: 'get',
                            shouldThrow: true,
                        })];
                case 1:
                    body = (_a.sent()).body;
                    return [2 /*return*/, body];
                case 2:
                    error_1 = _a.sent();
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); }, __assign({ revalidateOnMount: true }, config)), data = _c.data, error = _c.error;
    var user = slug ? data : me;
    var interests = (0, useInterests_1.default)(user === null || user === void 0 ? void 0 : user.id).data;
    var hasGroups = (0, useUserGroups_1.useUserHasGroups)(user === null || user === void 0 ? void 0 : user.id);
    if (error) {
        return { errors: error };
    }
    if (user) {
        var profileCompletion = void 0;
        if (interests !== undefined && hasGroups !== undefined) {
            profileCompletion = [];
            if (user.bio && ((_a = user.avatar) === null || _a === void 0 ? void 0 : _a.url) && interests.length) {
                profileCompletion.push(types_1.PROFILE_COMPLETION.INFO);
            }
            if (hasGroups) {
                profileCompletion.push(types_1.PROFILE_COMPLETION.GROUPS);
            }
        }
        var isMe = me && (slug === 'me' || user.slug === me.slug);
        return { user: user, isMe: isMe, profileCompletion: profileCompletion, errors: error };
    }
    return { errors: error };
};
exports.useProfile = useProfile;
//# sourceMappingURL=useProfile.js.map